import React, { useState, useEffect, useContext} from 'react';
import { Box, TextField, Typography, Button, Avatar,  Stack, Select, MenuItem, Table, TableBody, TableCell, TableRow, FormControl, InputLabel } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AuthContext from '../../contexts/AuthContext';
import { setSnackDetails, setMetaData, setSweetAlert } from '../../service/actions/common';
import axios from 'axios';
import { setCustomerData } from '../../service/actions/index';

import { useFormik } from 'formik';
import * as yup from 'yup';
const validationSchema = yup.object({
    first_name: yup
        .string('Enter First Name')
        .trim()
        .required('First Name is required'),
    last_name: yup
        .string('Enter Last Name')
        .trim()
        .required('Last Name is required'),
    email: yup
        .string('Enter your email')
        .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Enter a valid email')
        .required('Email is required'),    
    });

const UsersProfile = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let { custId } = useParams();
    const { token, user } = useContext(AuthContext);
    const formatOptions = JSON.parse(process.env.REACT_APP_DATE_TIME_FORMAT || '{}');
    const profile = useSelector((state) => state.customerData);
    let metaData = useSelector((state) => state.metaData); 
    const catchError = async (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                navigate('/sign-in');
            } else if (error.response.status >= 500) {
                dispatch(setSweetAlert({ open: true, title: 'Server Error', text: '' }));
            } else if (error.response.status === 400) {
                dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
                return false;
            } else {
                dispatch(setSweetAlert({ open: true, title: 'Error', text: '' }));
            }
        } else if (error.request) {
            dispatch(setSweetAlert({ open: true, title: 'Connection Lost', text: '' }));
        } else {
            dispatch(setSweetAlert({ open: true, title: 'Error', text: 'An unknown error occurred.' }));
        }
    };

    const fetchCustomer = async () => {
        if (user && token) {
            try {
                let uri = `/customer/${custId}`;
                const response = await axios.get(uri, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                const customer_user = response.data.customer;
                dispatch(setCustomerData(response.data.customer));
                const created_at = Date.parse(customer_user.createdAt);
                const last_active_dt = Date.parse(customer_user.last_active);
                setRows([
                    {
                        id: 1,
                        title: 'Number of purchases',
                        value: response.data.numberOfTxn
                    },{
                        id: 2,
                        title: 'Number of reports used',
                        value: response.data.totalCreditsUsed
                    },{
                        id: 3,
                        title: 'Number of reports purchased',
                        value: response.data.totalCreditsPurchased
                    },{
                        id: 4,
                        title: 'Amount spent',
                        value: '$' + response.data.totalAmount
                    },{
                        id: 5,
                        title: 'Last Active',
                        value: new Intl.DateTimeFormat('en-US', formatOptions).format(last_active_dt)
                    },{
                        id: 6,
                        title: 'Date Joined',
                        value: new Intl.DateTimeFormat('en-US', formatOptions).format(created_at)
                    },
                ]);

                metaData  = {
                    title: `App Users | ${customer_user?.email}`,
                    description: `App Users | ${customer_user?.email}`
                };
                dispatch(setMetaData(metaData));
            } catch (error) {
                catchError(error);
            }
        }
    };
    useEffect(() => {
        fetchCustomer();        
        // eslint-disable-next-line
    }, []);

    const [rows, setRows] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [preview, setPreview] = useState('');
    const formik = useFormik({
        initialValues: {
            cust_id: profile?._id,
            first_name: profile?.first_name,
            last_name: profile?.last_name,
            email: profile?.email,
            status: profile?.status
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                if (user && token ) {
                    const response = await axios.post('/customer/update-profile', values, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    if (response.status === 200) {
                        dispatch(setCustomerData(response.data.customer));
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'success'}));
                        setIsEdit(false);
                    } else {
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'error'}));
                    }
                } else {
                    console.log('unauthorized');
                }
            } catch (error) {
                catchError(error);
            }
        },
    });

  const handleProfilePictureChange = async (event) => {
    if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        const formData = new FormData();    
        formData.append('profilePhoto', file);
        setPreview(URL.createObjectURL(file));
        formData.append('cust_id', profile._id);
        try {
            if (user && token ) {
                const response = await axios.post('/customer/profile-photo', formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        "Content-type": "multipart/form-data",
                    },
                });
                dispatch(setCustomerData(response.data.customer));
                dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'success'}));
            } else {
                console.log('unauthorized');
            }
        } catch (error) {
            catchError(error);
        }
    }    
  };
  
  return (
    <Box>
        <Stack direction="row" justifyContent="flex-start" sx={{ width: '100%' }}>
            <Button component={Link} to="/app-users">
                <ArrowBackIcon />
            </Button>
            <Typography variant="h4">{profile?.first_name} {profile?.last_name}</Typography>
            { isEdit ? (
            <Button color="primary" variant="contained" onClick={formik.handleSubmit} sx={{ borderRadius: 28, ml: "auto" }} >
                Save
            </Button>
            ) : (
            <Button color="primary" variant="outlined" onClick={(e) => {setIsEdit(true)}} sx={{ borderRadius: 28, ml: "auto" }} >
                Edit
            </Button>
            )}

        </Stack>
        <Box
            sx={{
                margin: 'auto',
                padding: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                border: '1px solid #ddd',
                borderRadius: 2,
                boxShadow: 1,
                mt:2,
                backgroundColor:'#FFF'
            }}
        >
        <Stack direction="column" justifyContent="center" spacing={2} sx={{ width: '40%' }}>
            <Avatar
                alt={profile.username}
                src={ profile.profilePhoto || preview}
                sx={{ width: 150, height: 150 }}
            />
            { isEdit ? (
            <Button variant="outlined" component="label" sx={{ mt: 2, borderRadius: 28, width: '40%' }}>
                Replace Image
                <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleProfilePictureChange}
                />
            </Button>
            ) : (
                ''
            )}
        </Stack>
        { isEdit ? (
        <Stack direction="column" justifyContent="center" spacing={2} sx={{ width: '40%' }}>
            <TextField
                label="First Name"
                name="first_name"
                id="first_name"
                type="text"
                required
                autoFocus
                value={formik.values.first_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                helperText={formik.touched.first_name && formik.errors.first_name}
            />
            <TextField
                label="Last Name"
                name="last_name"
                id="last_name"
                type="text"
                required
                value={formik.values.last_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                helperText={formik.touched.last_name && formik.errors.last_name}
            />
            <TextField
                label="Email"
                name="email"
                id="email"
                type="text"
                required
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
            />
            <FormControl fullWidth variant="outlined" error={formik.touched.status && Boolean(formik.errors.status)}>
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                    id="status"
                    name="status"
                    label="Status"
                    labelId="status-label" 
                    fullWidth
                    value={formik.values.status || 0}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Inactive</MenuItem>
                </Select>
            </FormControl> 


        </Stack>
        ) : (
            <Stack direction="column" justifyContent="center" spacing={2} sx={{ width: '40%', ml:3, mt:2 }}>
                <Typography variant="p" sx={{ fontWeight: 'bold' }}>First Name</Typography>
                <Typography variant="p">{profile?.first_name}</Typography>

                <Typography variant="p" sx={{ fontWeight: 'bold' }}>Last Name</Typography>
                <Typography variant="p">{profile?.last_name}</Typography>

                <Typography variant="p" sx={{ fontWeight: 'bold' }}>Email</Typography>
                <Typography variant="p">{profile?.email}</Typography>

                <Typography variant="p" sx={{ fontWeight: 'bold' }}>Status</Typography>
                <Typography variant="p">{profile?.status === 1 ? 'Active' : 'Inactive'}</Typography>
            </Stack>
        )}
    </Box>


        <Box
        sx={{
            margin: 'auto',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            border: '1px solid #ddd',
            borderRadius: 2,
            boxShadow: 1,
            mt:2,
            backgroundColor:'#FFF'
        }}
        >
            <Typography variant="h5" gutterBottom>Stats</Typography>
            <Table sx={{ width: '50%' }} aria-label="simple table">                
                <TableBody>
                    {rows.map((row) => (
                        <TableRow
                        key={row.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell sx={{ fontWeight: 'bold' }} align="left">{row.title}</TableCell>
                        <TableCell align="left">{row.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    </Box>
  );
};

export default UsersProfile;
